import { Button } from 'react-bootstrap'
import { PhotoProvider, PhotoView } from 'react-photo-view';
import './styles.css'
import { saveAs } from 'file-saver';


const Index = ({ message, friendName, editedText = '' }) => {
	const hasReply = message.reply_id && message.reply;

	const handleDownload = (src) => {
		saveAs(src, 'image.png');
	};

	return (
		<div className='message-wrapper'>
			{hasReply && (
				<div className="reply-container">
					<div className="reply-content">
						<p className="reply-sender">{friendName}</p>
			
						{
							message.reply.type === 'text' ? (
								<p className="reply-text">{message.reply.message}</p>
							) : (
								<div className="d-inline-block py-2 px-3 bg-light chat-popup-message message-right font-size-12 fw-medium" style={{ marginRight: '5px' }}>
									<PhotoProvider toolbarRender={({ rotate, onRotate, scale, onScale }) => (
										<div>
											<Button onClick={() => onRotate(rotate + 90)} style={{ cursor: 'pointer',  marginLeft: '10px', display: 'contents' }}>
												<span className="material-symbols-outlined font-size-18 icon-rtl" style={{ margin: '10px' }}>
												rotate_right
												</span>
											</Button>

											<Button onClick={() => onRotate(rotate - 90)} style={{ cursor: 'pointer',  marginLeft: '10px', display: 'contents' }}>
												<span className="material-symbols-outlined font-size-18 icon-rtl" style={{ margin: '10px' }} >
												rotate_left
												</span>
											</Button>

											<Button className="d-contents" onClick={() => onScale(scale - 0.1)} style={{ marginLeft: '10px', display: 'contents' }}>
											<span className="material-symbols-outlined font-size-18 icon-rtl" style={{ margin: '10px' }}>
												zoom_out
												</span>
											</Button>

											<Button onClick={() => onScale(scale + 0.1)} style={{ marginLeft: '10px', display: 'contents' }}>
											<span className="material-symbols-outlined font-size-18 icon-rtl" style={{ margin: '10px' }}>
												zoom_in
												</span>
											</Button>

											<Button className="d-contents" onClick={() => handleDownload(message.reply.message)} style={{ marginLeft: '10px', marginRight: '10px', display: 'contents' }}>
											<span className="material-symbols-outlined font-size-18 icon-rtl" style={{ margin: '10px' }}>
													file_download
													</span>
											</Button>
										</div>
									)}>
										<PhotoView src={message.reply.message} >
											<img src={message.reply.message} style={{ maxWidth: '100%', maxHeight: '200px', borderRadius: '8px' }} alt="" />
										</PhotoView>
									</PhotoProvider>
								</div>
							)
						}
					</div>
				</div>
			)}

			<p className="message-text">{editedText ? editedText : message.message}</p>
		</div>
	);
};

export default Index;